// Prázdný stav podle docs/04: podklad --bg-empty, bez ikony, věta „Zatím žádné …“ a nejvýš jedno
// primární tlačítko (nebo tlačítko s důvodem, když akce zatím nejde).
import type { ReactNode } from 'react';
import './komponenty.css';

interface Props {
  /** Věta, např. „Zatím žádné oblíbené.“ */
  text: string;
  /** Jedno primární tlačítko (volitelné). */
  akce?: ReactNode;
  className?: string;
}

export function PrazdnyStav({ text, akce, className }: Props) {
  return (
    <div className={`prazdny-stav${className ? ` ${className}` : ''}`}>
      <p className="prazdny-stav__text">{text}</p>
      {akce && <div className="prazdny-stav__akce">{akce}</div>}
    </div>
  );
}
